// extracted by mini-css-extract-plugin
export default {"title":"title-wh60m","text":"text-aKZGJ","body":"body-qEY9c","paragraph":"paragraph-NQKJW","redRow":"redRow-PmY9V"};